var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":function($event){return _vm.scrollToTop()}}},[_c('b-button',{attrs:{"variant":_vm.variant,"size":_vm.size}},[_c('b-icon-chevron-compact-up',{staticClass:"mt-1"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }